import eventRegistry from "./event-registry";

import HstRequest from "./hstRequest/request";
import { EventResult } from "./enums"
import logger from "./logger"

let hstRequest = new HstRequest()
// websocket 请求拦截
hstRequest.interceptors.response.use(({data, config}) => {
  // 订阅事件
  if (data === EventResult.NOADDR && config.retryConfig.num < config.retryConfig.max) {
    config.retryConfig.num ++
    logger.warn(`start retry receive media: ${config.retryConfig.num}`)
    return hstRequest.request(config)
  }
  return data
}, (err) => {
})

// 使用事件回调的方式来封装Promise以方便外部处理异步调用
const promiseHandler = function(eventName, fn) {
  return new Promise((resolve, reject) => {
    //FIXME：这里是否要考虑once场景
    eventRegistry.on(eventName, function() {
      // 第一个参数为异步调用的处理结果
      let result = Array.prototype.shift.call(arguments);
      if (parseInt(result) === 0) {
        fn && fn.call(this);
        resolve(...arguments);
      } else {
        reject(...arguments);
      }
    });
  });
};

export {
  promiseHandler,
  hstRequest
}



